import { Component, Input, OnInit } from '@angular/core';
import { LoadingService } from './loading-service.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  // baseHref = environment.baseHref;
  
  @Input() loadingFull = false;


  constructor(
    public loadingService: LoadingService
  ) { }

  ngOnInit(): void {

  }

 

}
